import React from "react";
import MRPImg from "../assets/images/new-dashboards/mrp.png";
import TelescopeIcon from "../assets/icons/telescope.svg";
import MoneyIcon from "../assets/icons/money.svg";
import { ContactForm } from "../components/ContactForm";

export function LucidMRP() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="newModuleHeader">
        <div className="newBackground"></div>
        <h3 className="mainSubhead white">Alpaca MRP</h3>
        <p className="body-text white">
          The foundational app that streamlines manufacturing planning and
          centralizes data collection.
        </p>
        <img src={MRPImg} alt="Alpaca MRP Dashboard" className="module-img" />
      </section>

      <section className="module-info">
        <div>
          <p className="body-text left">
            Avoid the limitations of complicated spreadsheets or out-of-the-box
            software packages and get more from your MRP program with Alpaca
            MRP. This foundational app is
            <strong>
              {" "}
              designed to increase efficiency by automating tasks and improve
              interdepartmental communication
            </strong>{" "}
            by pulling data from your NAV. Alpaca MRP organizes the information
            in a quick and efficient visual format, available in one, central
            location.
          </p>

          <p className="body-text left">
            Gone are the days of hand-written notes and manual data entry that
            leaves room for errors and unnecessary operational risks. By
            centralizing data, managers can assess inventory levels and
            requirements, production planners can determine how much to
            manufacture and when resources would be available, while accounting
            can keep an eye on cash flow and costs, etc.
          </p>

          <p className="body-text left">
            <strong>Alpaca MRP provides a 360° view of your operations;</strong>{" "}
            a tool where you can discover opportunities to save time, optimize
            your resources and assets, improve your overall efficiency, and
            drive your bottom line.
          </p>
        </div>

        <div>
          <div className="container-img-text">
            <img src={TelescopeIcon} alt="Simple Forecasting Icon" />
            <div>
              <h3 className="smallSubhead">Simple Forecasting</h3>
              <p className="small-text">
                With just a few clicks, analyze your current inventory, review
                open purchase orders, work orders, manufacturing orders and
                sales orders. Maintain and apply sales forecasts to future
                production schedules.
              </p>
            </div>
          </div>

          <div className="container-img-text">
            <img src={MoneyIcon} alt="Financial Overview Icon" />
            <div>
              <h3 className="smallSubhead">Financial Overview</h3>
              <p className="small-text">
                Make better-informed financial decisions by streamlining your
                manufacturing process through production planning, scheduling
                and detailed inventory management.
              </p>
            </div>
          </div>
        </div>
      </section>
      <ContactForm />
    </>
  );
}
